import { STORIES_PATH } from "./App";

export const getStorySlug = (storyHeader: string): string =>
  `${STORIES_PATH}/${storyHeader.replace(/\s+/g, "-").toLowerCase()}`;
